import styled from 'styled-components';

export const HeaderStyled = styled.h1`
  max-width: 90%;
  padding-top: 3rem;
  padding-bottom: 1rem;
`;
